import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { BodySmallMedium } from '../../../fonts/typography/Typography';
import { MdCheckCircleOutline } from 'react-icons/md';
import { LayoutColors } from '@src/core/theme';

interface SuccessMessageProps {
  text: string;
  autoDisappear?: boolean;
  style?: React.CSSProperties;
}
const SuccessMessage = ({ text, autoDisappear = false, style }: SuccessMessageProps) => {
  const [visible, setVisible] = useState(!!text);

  useEffect(() => {
    if (autoDisappear) {
      setTimeout(() => {
        setVisible(false);
      }, 10000);
    }
  }, [autoDisappear]);

  return (
    <SuccessMessageStyles visible={visible} style={style}>
      <MdCheckCircleOutline color={LayoutColors.greenDark} size={18} />
      <span>{text}</span>{' '}
    </SuccessMessageStyles>
  );
};

export default SuccessMessage;

interface SuccessMessageStylesProps {
  visible: boolean;
}
const SuccessMessageStyles = styled.div<SuccessMessageStylesProps>`
  ${BodySmallMedium}
  color: ${LayoutColors.greenDark};
  background: ${LayoutColors.successLight};

  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  transition: all 0.1s ease-in;
  overflow: hidden;
  padding: ${(props) => (props.visible ? '8px' : '0px')};
  transform: ${(props) => (props.visible ? 'scaleY(1)' : 'scaleY(0)')};
  margin-bottom: ${(props) => (props.visible ? '16px' : '0px')};

  span {
    color: ${LayoutColors.greenDark};
  }
`;
